import React from 'react';
import Navigation from '../components/Navigation';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-page">
      <Navigation />
      
      {/* Header */}
      <div className="bg-gray-50 border-b border-gray-100 pt-20">
        <div className="max-w-3xl mx-auto px-6 py-12">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">Privacy Policy</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-12">
        <div className="prose prose-gray max-w-none">
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            Xerobrain Labs respects your privacy.
          </p>
          
          <p className="text-gray-600 leading-relaxed mb-6">
            We only collect information you voluntarily provide, such as when you contact us by email.
          </p>
          
          <p className="text-gray-600 leading-relaxed mb-6">
            We do not sell, rent, or share personal data with third parties.
          </p>
          
          <p className="text-gray-600 leading-relaxed mb-6">
            We may use basic analytics tools to understand how visitors use this website.
          </p>
          
          <p className="text-gray-600 leading-relaxed">
            For any privacy-related questions, contact us at{' '}
            <a 
              href="mailto:priyanshu@xerobrain.com" 
              className="text-[#002699] hover:underline"
            >
              priyanshu@xerobrain.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
